import { Component, Input, OnInit } from '@angular/core';

import { HeaderComponent } from '@coreui/angular-pro';
import { cilChevronLeft, cilChevronRight } from '@coreui/icons';
import { StorageService } from '@shared/services';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit {
  constructor(private _storageService: StorageService) {
    super();
  }

  ngOnInit(): void {
    const user = this._storageService.getUser()
    if(user){
      this.username = `${user.firstname} ${user.lastname}`
    }
  }

  @Input() sidebarId: string = 'sidebar1';
  icons = { cilChevronLeft, cilChevronRight };
  username = 'Mi perfil';
}
